import React, { useEffect } from 'react';
import { Button, Input, InputRed } from 'components'
import useApp from 'hooks/useApp'

const CareerSecurity = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>주민등록번호 뒷자리를<br />모두 입력해주세요.</h3>
				<p className="guide-title mt_20">입력한 정보는 커리어 정보 조회를 위해서만 사용돼요!</p>

				<p className="guide-title mt_40">주민등록번호</p>
				<div className="flex-align_center mt_10">
					<div className="flex--item_1">
						<Input type="text" placeholder="주민번호 앞 6자리" id="" maxlength="6" />
					</div>
					<span style={{ margin: "0 0.5rem" }}>-</span>
					<div className="form-group flex--item_1">
						{/* 숫자 입력 시 폰트사이즈 3rem */}
						<Input type="password" placeholder="숫자 6자리" id="" maxlength="6" style={{ paddingLeft: "2rem", letterSpacing: "1rem", paddingRight: 0 }} />
						<span className="number">2</span>
					</div>
				</div>

				<InputRed text="잘못된 주민등록번호에요. 다시 입력해주세요." show={true} />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled>다음</Button>
			</div>
		</div>
	)
}

export default CareerSecurity